export default __webpack_public_path__ + "static/media/loading-campos.61152b8b.svg";